import React, { useEffect, useState } from "react"
import moment from "moment"

import PatientChip from "../../../PatientChip"
import AppointmentCalendarUtils from "../../../../AppointmentCalenderUtils"
import "./EachDayOfMonth.scss"

export default function EachDayOfMonth({
  day,
  currentlySelected,
  appointments,
  onButtonClick,
  disablePopup,
  changeDay,
  outline,
  userRole,
  slotDuration,
  bedSlotDuration,
  show,
  reloadAppointments
}: any) {
  const [patients, updatePatients] = useState<any>()

  const [highlightDay, updateHighlightDay] = useState<any>()

  useEffect(() => {
    const temp = AppointmentCalendarUtils.checkIfSameMonth(
      day.each,
      currentlySelected
    )
    updateHighlightDay(temp)
  }, [day])

  useEffect(() => {
    const temp = appointments?.filter((eachApp: any) =>
      moment(eachApp?.scheduleDate).isSame(moment(day.each), "days")
    )
    updatePatients(temp)
  }, [appointments])

  return (
    <div key={day.index} className="each-day">
      <div className={`date ${highlightDay ? "same" : "different"}`}>
        {moment(day.each).format("DD")}
      </div>
      <div className="patients">
        {patients?.slice(0, 3)?.map((eachApp: any) => (
          <PatientChip
            patient={eachApp}
            onButtonClick={onButtonClick}
            disablePopup={disablePopup}
            outline={outline}
            userRole={userRole}
            slotDuration={eachApp?.appointmentType === "IPD" ? bedSlotDuration : slotDuration}
            showModal={show}
            reloadAppointments={reloadAppointments}
          />
        ))}
      </div>
      {patients?.length > 3 ? (
        <div className="remaining-count cursor-pointer" onClick={() => changeDay(day?.each)}>
          <div className="count text-center">{patients?.length - 3}</div>
          <div className="more">more</div>
        </div>
      ) : (
        <div className="empty-count" />
      )}
    </div>
  )
}
